module.exports = __webpack_public_path__ + "img/back_btn.1b4135c3.png";